export const signinRoute = "/sign-in";
export const signupRoute = "/sign-up";
export const resetPasswordRoute = "/reset-password";

export const homeRoute = "/home";
export const storiesRoute = "/stories";
export const storyDetailsRoute = "/story";
export const communitiesRoute = "/support/community";
export const addStoryRoute = "/share-your-feelings";
export const editStoryRoute = "/story/update";
export const myAccountRoute = "/my-account";
export const contactUsRoute = "/contact-us";
export const faqs = "/faqs";
export const otherUserProfile = "/user";

export const privateRoutes = {
  profileRoute: "/profile",
  bookmarkedStoriesRoute: "/bookmarked-stories",
  privateDirectoryRoute: "/private-stories",
  myQueriesRoute: "/queries/list",
  chatRoute: "/messages",
};
